import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Camera, CameraTimeline } from '../models';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import Hls from 'hls.js';
import * as dashjs from 'dashjs';
import { AnalyticsService } from 'app/Shared/Services/firebase-analytics.service';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/model';
import { CameraActions } from '../Services/actions';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { ValidationResponseHandlerModule } from 'app/Shared/ValidationResponse/validation-response-handler';
import { differenceInDays, format } from 'date-fns';
import { showAlert } from 'app/Shared/Helpers/showAlert';

import { isSameDay, isSameHour } from 'date-fns';
export enum CameraTimelineInterval {
    DAY = 24,
    HOUR = 1,
    MINUTES = 15
}

@Component({
    selector: 'app-camera-live',
    templateUrl: './camera-live.component.html',
    styleUrls: ['./camera-live.component.scss'],
    standalone: false
})

export class CameraLiveComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('picker1') picker1: MatDatepicker<Date>;
    @ViewChild('datepickerToggle', { read: ElementRef }) toggle: ElementRef;

    readonly videoTimeline$ = this.store.select((state: AppState) => state.camera.videoTimeline);
    readonly cameraRecordingByDate$ = this.store.select((state: AppState) => state.camera.cameraRecordingByDate);
    readonly playlist$ = this.store.select((state: AppState) => state.camera.playlist);
    pageName = 'camera-live';
    @Output() modalClose = new EventEmitter<string>();

    videoSub: Subscription;
    timelineSub: Subscription;
    cameraRecordingSub: Subscription;
    cameraTimelineSub: Subscription;
    private visibilityChangeHandler: (() => void) | null = null;
    private videoLoadedMetadataHandler: (() => void) | null = null;
    private videoPlayHandler: (() => void) | null = null;
    private fullscreenChangeHandler: (() => void) | null = null;

    hls: Hls;
    dash = dashjs.MediaPlayer().create();
    dash_is_live = false;
    intervalUnsubscribe: NodeJS.Timeout;
    video: HTMLVideoElement;
    playButton: HTMLElement;
    playbackIcons: NodeListOf<HTMLElement>;
    fullScreenButton: HTMLButtonElement;
    videoContainer: HTMLElement;
    fullScreenIcons: NodeListOf<SVGUseElement>;
    private playStartTime: number | null = null;
    @ViewChildren('video') openVideo: QueryList<ElementRef>;
    controlsVisible = false;
    isDatePickerVisible = false;
    selectedDate = new FormControl<Date | null>(null);
    selectedDateCalendar: Date | null = null;
    isFullscreen = false;
    speed = 1;
    selected = ['1x'];
    isLive = true;
    currentRecording: any;
    currentDate: Date;
    currentInterval: CameraTimelineInterval = CameraTimelineInterval.DAY;
    progressTime: Date;
    isDownloading: boolean;
    dateFormat: string;
    isLoadingRecording: boolean;
    url: string;

    camera: Camera;
    camName: string;
    freezeStreaming: boolean;
    freezeTimeoutUnsub: NodeJS.Timeout;
    videoControls: HTMLElement;
    segmentsRecords: CameraTimeline[];
    totalMinutes = 1440;
    noRecording = false;
    dateRange = [];
    beginTime;
    endTime;
    beginDate;
    endDate;
    visibility = false;
    timeClicked;
    selectedValueOfSelectTime = 24;
    optionsOfSelectTime = [
        { value: CameraTimelineInterval.MINUTES, label: '15 minutos' },
        { value: CameraTimelineInterval.HOUR, label: '1 hora' },
        { value: CameraTimelineInterval.DAY, label: '24 horas' }
    ];

    cameraAlias: string;
    today;
    planAlias: number;
    dateClass;
    isDateDisabled;
    minAvailableDate;
    dataSelectionOfCalendar(event: MatDatepickerInputEvent<Date>) {
        this.selectedDate.setValue(event.value);
    }
    filterDateInterval;

    intervals = {
        1: CameraTimelineInterval.HOUR,
        15: CameraTimelineInterval.MINUTES,
        24: CameraTimelineInterval.DAY
    };
    minutes = {
        1: 60,
        15: 15,
        24: 1440
    };
    private hideTimeout!: ReturnType<typeof setTimeout>;

    isPartner = localStorage.getItem('profile_name') === 'cd343bfc-17e8-11ec-9621-0242ac130002';
    isAssociate = localStorage.getItem('profile_name') === 'f29868c7-b4c5-4963-9ae8-1dd95699d6c3';
    isMaster = localStorage.getItem('profile_name') === '7d4e9f24-17e8-11ec-9621-0242ac130002';
    isMasterAssociate = localStorage.getItem('profile_name') === '7415bb4a-c1e9-401d-870a-7af65a8e3acd';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private firebaseAnalyticsService: AnalyticsService, private readonly store: Store<AppState>, private validationResponse: ValidationResponseHandlerModule) {
    }

    isCurrentDate(date: Date): boolean {
        const now = new Date();
        if (this.totalMinutes === 1440) {
            return isSameDay(date, now);
        } else if (this.totalMinutes === 60) {
            return isSameHour(date, now);
        } else if (this.totalMinutes === 15) {
            return this.isIn15MinutesInterval(date);
        }
    }

    getCameraTimeline(interval: CameraTimelineInterval, currentDate?: Date): void {
        const payload = {
            camera_id: this.camera.id || this.camera.id_camera,
            user_sub: localStorage.getItem('sub'),
            timeline_interval: interval,
        };
        if (this.isPartner || this.isAssociate) {
            payload['child_sub'] = localStorage.getItem('clientView') || this.camera.sub;
        }
        if (this.isMaster || this.isMasterAssociate) {
            payload['partner_sub'] = localStorage.getItem('partnerSub');
        }
        if (currentDate) {
            payload['date_start'] = format(currentDate, 'yyyy-MM-dd HH:mm:ss');
        }
        this.store.dispatch(CameraActions.get_camera_timeline(payload));
    }

    getVideoIsPaused() {
        return this.video?.paused;
    }

    getRecordingByTimeClicked(event: any) {
        this.timeClicked = event;
        this.currentDate = new Date(event);
        this.store.dispatch(CameraActions.get_camera_recording_by_date({
            camera_id: this.camera.id,
            user_sub: localStorage.getItem('sub'),
            time_to_search: event
        }));
    }

    updateProgressTime(event) {
        this.progressTime = event;
    }

    seekAndInitializeVideo() {
        if (!this.currentRecording) {
            return;
        }
        const startTime = new Date(this.currentRecording.media_create_date).getTime();
        this.currentDate = new Date(this.currentRecording.media_create_date);
        const clickedTimeMs = new Date(this.timeClicked).getTime();
        const seekTime = (clickedTimeMs - startTime) / 1000;
        if (seekTime > 0 && seekTime < this.video.duration) {
            this.video.currentTime = new Date(this.currentRecording.media_create_date).getTime() + seekTime;
            this.currentDate = new Date(new Date(this.currentRecording.media_create_date).getTime() + seekTime);
        }
        this.video.play();
    }

    ngOnInit(): void {
        this.camera = this.data.data.camera;
        this.camName = this.camera.alias;
        this.cameraAlias = String(this.camera.alias);
        this.today = new Date();
        this.planAlias = this.camera.plan_details?.length ? +this.camera.plan_details[0].alias || 1 : 1;
        const daysToSubtract = isNaN(this.planAlias) ? 0 : this.planAlias - 1;
        this.minAvailableDate = new Date(this.today);
        this.minAvailableDate.setDate(this.today.getDate() - daysToSubtract);
        this.isLoadingRecording = false;
        this.isDateDisabled = (date: Date): boolean => {
            return moment(date).isBefore(this.minAvailableDate, 'day');
        };

        this.dateClass = (date: Date) => {
            return this.isDateDisabled(date) ? 'disabled' : '';
        };
        this.filterDateInterval = (dateInterval: Date | null): boolean | null => {
            if (dateInterval > this.today) { return false; }
            if (isSameDay(this.today, dateInterval)) { return true; }
            const difference = differenceInDays(this.today, dateInterval);
            return difference + 1 <= this.planAlias;
        };
        this.currentInterval = CameraTimelineInterval.DAY;
        this.getCameraTimeline(this.currentInterval);
        this.currentDate = new Date();
        this.dash.updateSettings(
            {
                'streaming': {
                    delay: {
                        'liveDelay': 12,
                    },
                    retryAttempts: {
                        MPD: 3,
                        XLinkExpansion: 3,
                        InitializationSegment: 3,
                        IndexSegment: 3
                    },
                    buffer: {
                        fastSwitchEnabled: false,
                        'bufferToKeep': 20, // Amount of buffer to keep in seconds (past content)
                        'stableBufferTime': 12, // Stable buffer time (in seconds) to maintain before switching quality
                        'bufferTimeAtTopQualityLongForm': 60, // Buffer time for long-form content at top quality (in seconds)
                        'bufferTimeAtTopQuality': 30, // Buffer time at top quality (in seconds),
                    },
                    'timeShiftBuffer': {
                        fallbackToSegmentTimeline: true
                    },

                },
                debug: {
                    'dispatchEvent': true,
                    logLevel: dashjs.LogLevel.LOG_LEVEL_NONE
                }
            }
        );
        this.cameraRecordingSub = this.cameraRecordingByDate$.subscribe(result => {
            if (result) {
                if (result.length > 0) {
                    this.currentRecording = result[0];
                    this.isLoadingRecording = true;

                    if (this.isLive) {
                        this.isLive = false;
                        this.video?.pause();
                        this.hls.stopLoad();
                        this.hls.detachMedia();
                    }

                    this.video.oncanplay = () => {
                        console.log('oncanplay', this.video.duration);
                        this.isLoadingRecording = false;
                        this.video.playbackRate = this.speed;
                        this.video.play().catch(error => console.log('Erro ao dar play:', error));
                    };

                    this.video.src = this.currentRecording.url;
                    this.video.load();
                } else {
                    this.video?.pause();
                    this.noRecording = true;
                }
            }
        });

        this.getElements();
        this.cameraTimelineSub = this.videoTimeline$
            .subscribe(result => {
                if (Array.isArray(result)) {
                    if (result?.length > 0) {
                        this.segmentsRecords = result;
                        // quando o usuario der um shift na timeline, a primeira gravacao deve ser carregada
                        if (!this.isCurrentDate(this.currentDate)) {
                            this.getRecordingByTimeClicked(this.segmentsRecords[0].start_time);
                        }
                    } else {
                        this.noRecording = !this.isLive;
                        this.isLoadingRecording = false;
                        this.validationResponse.validationResponseHandler(400, 'camera-live', 'no-timeline', 'Não existem gravações neste intervalo para esta câmera');
                    }
                }
            });
        // this.timelineResult();
        this.getVideosResult();
    }

    ngAfterViewInit() {
        this.picker1.openedStream.subscribe(() => {
            setTimeout(() => {
                this.picker1.select(this.currentDate);
                this.nuclearSolution();
            }, 350);
        });

        const tryBindVideo = () => {
            const ref = this.openVideo?.first?.nativeElement as HTMLVideoElement | undefined;
            if (!ref) { setTimeout(tryBindVideo, 50); return; }

            this.video = ref;
            this.videoControls = document.getElementById('video-controls');

            if (this.isLive) {
                this.loadPlayer(this.camera);
            }

            this.addEvents();
            this.detectNotPlayingAndCheckHvc(this.camera?.url_view);
        };

        tryBindVideo();
    }

    private async detectNotPlayingAndCheckHvc(playlistUrl?: string): Promise<void> {
        const v = this.video;
        if (!v) {return; }

        const started = await new Promise<boolean>((resolve) => {
            let done = false;

            const ac = new AbortController();
            const { signal } = ac;

            const finish = (ok: boolean) => {
                if (done) {return; }
                done = true;
                ac.abort();
                resolve(ok);
            };

            const timer: number = window.setTimeout(() => {
                finish(false);
            }, 6000);

            const onCanplay = () => { clearTimeout(timer); finish(true); };
            const onPlaying = () => { clearTimeout(timer); finish(true); };
            const onError   = () => { clearTimeout(timer); finish(false); };
            const onEmptied = () => { clearTimeout(timer); finish(false); };
            const onStalled = () => {};

            v.addEventListener('canplay', onCanplay, { signal });
            v.addEventListener('playing', onPlaying, { signal });
            v.addEventListener('error',   onError,   { signal });
            v.addEventListener('emptied', onEmptied, { signal });
            v.addEventListener('stalled', onStalled, { signal });
        });

        if (!started) {
            await this.checkPlaylistForHvc(playlistUrl);
        }
    }

    private codecToastShown = false;

    private showCodecUnsupportedToast(): void {
        if (this.codecToastShown) {return; }
        this.codecToastShown = true;
        showAlert(
            'Seu navegador atual não suporta o codec H.265. Recomendamos utilizar outro navegador (ex: Firefox) ou alterar o codec da câmera para H.264.',
            'danger'
        );
    }



    private async checkPlaylistForHvc(explicitUrl?: string): Promise<void> {
        const v = this.video;
        if (!v) {return; }

        const url: string = explicitUrl || v.currentSrc || v.src || '';
        if (!url || url.startsWith('blob:') || !url.includes('.m3u8')) {return; }

        try {
            const res = await fetch(url, { cache: 'no-cache', credentials: 'same-origin' });
            if (!res.ok) {return; }

            const text = await res.text();
            const hasHvc = /CODECS\s*=\s*"[^"]*hvc[^"]*"/i.test(text);
            if (hasHvc) {
                this.showCodecUnsupportedToast();
            }
        } catch {
        }
    }


    private nuclearSolution() {
        if (document.getElementById('datepicker-force-styles')) { return; }
        const style = document.createElement('style');
        style.id = 'datepicker-force-styles';
        style.innerHTML = `
          /* Estilo para datas desabilitadas */
          .mat-datepicker-content .mat-calendar-body-disabled {
            opacity: 0.5 !important;
            background-color: #F3F9FF !important;
          }

          
          /* Tooltip customizado - versão absoluta */
          .mat-datepicker-content .mat-calendar-body-disabled:hover::after {
            content: 'sem gravação disponível' !important;
            position: absolute !important;
            width: 182px !important;
            height: 32px !important;
            border-radius: 8px !important;
            padding: 8px 16px !important;
            gap: 10px !important;
            background: #002D59 !important;
            color: white !important;
            font-size: 12px !important;
            z-index: 9999 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            opacity: 1 !important;
            top: -40px !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
          }
        `;

        document.head.appendChild(style);
    }

    monitorVideoDisplay(video: HTMLVideoElement) {
        this.intervalUnsubscribe = setInterval(() => {
            if (video.readyState < video.HAVE_ENOUGH_DATA && !this.dash_is_live) {
                this.hls.destroy();
                this.video.src = '';
                this.loadPlayer(this.camera, true);
                this.dash_is_live = true;
                clearInterval(this.intervalUnsubscribe);
            }
        }, 15000);
    }

    async loadPlayer(camera: Camera, switchToDash = false) {
        // Destroy previous HLS instance and remove dangling document/video listeners
        if (this.hls) {
            this.hls.destroy();
            this.hls = null;
        }
        if (this.visibilityChangeHandler) {
            document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
            this.visibilityChangeHandler = null;
        }
        if (this.videoLoadedMetadataHandler) {
            this.video?.removeEventListener('loadedmetadata', this.videoLoadedMetadataHandler);
            this.videoLoadedMetadataHandler = null;
        }
        if (this.videoPlayHandler) {
            this.video?.removeEventListener('play', this.videoPlayHandler);
            this.videoPlayHandler = null;
        }

        this.freezeStreaming = false;
        this.isLive = true;
        this.currentDate = new Date();
        this.noRecording = false;
        if (switchToDash) {
            const url = camera.url_view.replace('playlist.m3u8', 'manifest_mvnumber.mpd');
            this.dash.initialize(this.video, url, true);
        } else {
            if (Hls.isSupported()) {
                const hls = new Hls({
                    'enableWorker': true,
                    'lowLatencyMode': false,
                    'backBufferLength': 90,
                    debug: false
                });
                hls.loadSource(camera.url_view);
                hls.attachMedia(this.video);
                this.hls = hls;

                // this.monitorVideoDisplay(this.video);

                hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                    console.log(`Manifest loaded, found ${data.levels.length} quality level(s).`);
                    camera.status = true;
                });

                this.videoLoadedMetadataHandler = () => {
                    if (this.freezeTimeoutUnsub) {
                        clearTimeout(this.freezeTimeoutUnsub);
                        this.freezeTimeoutUnsub = null;
                    }
                    if (!document.hidden) {
                        this.freezeStream(hls);
                    }
                };
                this.video.addEventListener('loadedmetadata', this.videoLoadedMetadataHandler);

                this.videoPlayHandler = () => {
                    if (this.playStartTime == null) {
                        this.playStartTime = Date.now();
                    }
                };
                this.video.addEventListener('play', this.videoPlayHandler);

                // flush buffer streaming
                hls.on(Hls.Events.FRAG_BUFFERED, (event, data) => {
                    console.log('FRAG_BUFFERED', data);
                });

                hls.on(Hls.Events.BACK_BUFFER_REACHED, (event, data) => {
                    console.log('BACK_BUFFER_REACHED', data);
                });

                let hiddenStartTime;
                this.visibilityChangeHandler = () => {
                    if (document.hidden) {
                        hiddenStartTime = Date.now();

                        if (!this.video.paused) {
                            this.video.pause();
                        }
                        if (this.freezeTimeoutUnsub) {
                            clearTimeout(this.freezeTimeoutUnsub);
                            this.freezeTimeoutUnsub = null;
                        }
                    } else {
                        if (this.video.paused) {
                            this.video.play();
                        }
                        const timeAway = hiddenStartTime ? (Date.now() - hiddenStartTime) / 1000 : 0;

                        if (timeAway >= 60) {
                            this.video.playbackRate = 0;
                            hls.stopLoad();
                            this.freezeStreaming = true;
                            this.logVideoWatchTime();
                        } else {
                            this.freezeStream(hls);
                        }

                        hiddenStartTime = null;
                    }
                };
                document.addEventListener('visibilitychange', this.visibilityChangeHandler);

                hls.on(Hls.Events.ERROR, (event, data) => {
                    if (data.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR ||
                        data.details === Hls.ErrorDetails.BUFFER_APPENDING_ERROR) {
                        console.warn('Stream congelada, forçando recarga...');
                        this.camera.status = false;
                        hls.destroy();
                        return;
                    }
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            camera.status = false;
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                });

            }
        }
    }

    freezeStream(hls) {
        if (this.freezeTimeoutUnsub) {
            clearTimeout(this.freezeTimeoutUnsub);
        }

        this.freezeTimeoutUnsub = setTimeout(() => {
            if (!this.video.paused && this.video.src) {
                this.video.pause();
                hls.stopLoad();
                this.freezeStreaming = true;
                this.logVideoWatchTime();
            }
        }, 5 * 60 * 1000); // 5 minutos (corrigido o cálculo aqui: 5*60*1000 e não 5*60*3000)
    }

    ngOnDestroy(): void {
        if (this.videoSub) { this.videoSub.unsubscribe(); }
        if (this.timelineSub) { this.timelineSub.unsubscribe(); }
        if (this.cameraRecordingSub) { this.cameraRecordingSub.unsubscribe(); }
        if (this.cameraTimelineSub) { this.cameraTimelineSub.unsubscribe(); }

        if (this.visibilityChangeHandler) {
            document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
            this.visibilityChangeHandler = null;
        }
        if (this.videoLoadedMetadataHandler) {
            this.video?.removeEventListener('loadedmetadata', this.videoLoadedMetadataHandler);
            this.videoLoadedMetadataHandler = null;
        }
        if (this.videoPlayHandler) {
            this.video?.removeEventListener('play', this.videoPlayHandler);
            this.videoPlayHandler = null;
        }
        if (this.fullscreenChangeHandler) {
            document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
            this.fullscreenChangeHandler = null;
        }
        if (this.freezeTimeoutUnsub) {
            clearTimeout(this.freezeTimeoutUnsub);
        }

        this.store.dispatch(CameraActions.get_camera_recording_by_date_clear());
        this.hls?.destroy();
        this.dash?.reset();
        if (this.video) { this.video.src = ''; }
        this.currentRecording = null;
        this.isLive = true;
        this.logVideoWatchTime();
        this.playStartTime = null;
        clearInterval(this.intervalUnsubscribe);
        this.closeModal();
        this.codecToastShown = false;
    }

    logVideoWatchTime() {
        const duration = Math.ceil((Date.now() - this.playStartTime) / 1000);
        // Log the custom event in Firebase
        if (duration) {
            this.firebaseAnalyticsService.logEvent('video_watch_time', {
                duration_seconds: duration,
                camera_id: this.camera.id,
                plan: this.camera.id_plan,
                user: localStorage.getItem('sub')
            });

            this.playStartTime = null; // Reset the start time
            if (this.freezeTimeoutUnsub) {
                clearTimeout(this.freezeTimeoutUnsub);
            }
        }

    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event) {
        // event.preventDefault();
        if (this.playStartTime) {
            this.logVideoWatchTime();
            this.playStartTime = null; // Reset the start time
        }

    }

    closeModal() {
        this.modalClose.emit();
    }

    getElements() {
        this.playButton = document.getElementById('play');
        this.playbackIcons = document.querySelectorAll('.playback-icons use');
        this.fullScreenButton = document.getElementById('fullscreen-button') as HTMLButtonElement;
        this.videoContainer = document.getElementById('video-container');
        this.fullScreenIcons = this.fullScreenButton?.querySelectorAll('use');
    }

    addEvents() {
        // botão play/pause
        if (this.playButton) {
            this.playButton.addEventListener('click', this.togglePlay.bind(this));
        } else {
            console.warn('[PLAYER] playButton não encontrado');
        }

        // vídeo
        if (this.video) {
            this.video.addEventListener('play', this.updatePlayButton.bind(this));
            this.video.addEventListener('pause', this.updatePlayButton.bind(this));
            this.video.addEventListener('loadedmetadata', this.seekAndInitializeVideo.bind(this));
            this.video.addEventListener('mouseenter', this.showControls);
            this.video.addEventListener('mouseleave', this.hideControls);
        } else {
            console.warn('[PLAYER] video element não encontrado');
        }

        // fullscreen
        if (this.fullScreenButton) {
            this.fullScreenButton.addEventListener('click', this.toggleFullScreen.bind(this));
        } else {
            console.warn('[PLAYER] fullScreenButton não encontrado');
        }

        if (this.videoContainer) {
            this.videoContainer.addEventListener('fullscreenchange', this.updateFullscreenButton.bind(this));
        } else {
            console.warn('[PLAYER] videoContainer não encontrado');
        }
    }


    updatePlayButton() {
        if (this.video.paused && this.playButton && this.playbackIcons && this.playbackIcons.length > 3) {
            this.playButton.setAttribute('data-title', 'Play (k)');
        } else {
            this.playButton.setAttribute('data-title', 'Pause (k)');
        }
    }


    onVideoPause() {
        if (this.playStartTime) {
            // Calculate time spent in seconds
            this.logVideoWatchTime();
            this.playStartTime = null; // Reset the start time
        }
    }

    showControls(): void {
        this.controlsVisible = true;
        clearTimeout(this.hideTimeout);
    }

    hideControls(): void {
        this.hideTimeout = setTimeout(() => {
            this.controlsVisible = false;
        }, 300); // Adjust the timeout as needed
    }

    dataSelection(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;

        // Normalizar para comparação (apenas dia, mês, ano)
        const selectedDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()).getTime();
        const currentDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate()).getTime();

        // Se é a mesma data, não faz nada
        if (selectedDay === currentDay) {
            return;
        }

        // Atualizar data e carregar timeline
        this.currentDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
        this.isLoadingRecording = true;
        this.getCameraTimeline(this.currentInterval, this.currentDate);
    }

    togglePlay() {
        if (this.video.paused || this.video.ended) {
            if (this.isLive) { this.loadPlayer(this.camera); }
            this.video.play();
        } else {
            this.video.pause();
        }
    }

    forwardFn() {
        this.video.currentTime += 10;
    }

    replayFn() {
        this.video.currentTime -= 10;
    }

    changePlaySpeed(speed) {
        this.video.playbackRate = speed;
        this.speed = speed;
    }

    changeTimelineInterval(interval: number) {
        // this.currentDate = new Date();
        this.currentInterval = this.intervals[interval];
        this.totalMinutes = this.minutes[interval];
        this.getCameraTimeline(this.currentInterval, this.currentDate);
    }

    toggleFullScreen() {
        const videoElement = this.openVideo.first.nativeElement as HTMLVideoElement;
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            videoElement.requestFullscreen();
            if (!this.fullscreenChangeHandler) {
                this.fullscreenChangeHandler = () => this.controlsFullscreen(this.videoControls);
                document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
            }
        }
    }

    controlsFullscreen(videosControls: HTMLElement) {
        if (!document.fullscreenElement) {
            videosControls.classList.remove('isFullscreen');
            if (this.fullscreenChangeHandler) {
                document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
                this.fullscreenChangeHandler = null;
            }
        } else {
            videosControls.classList.add('isFullscreen');
        }
    }

    updateFullscreenButton() {
        this.fullScreenIcons.forEach(icon => icon.classList.toggle('hidden'));

        if (document.fullscreenElement) {
            this.fullScreenButton.setAttribute('data-title', 'Sair da tela cheia (f)');
        }
        else {
            this.fullScreenButton.setAttribute('data-title', 'Tela cheia (f)');
        }
    }

    getTime(newItem: [string, string]) {
        this.beginTime = newItem[0];
        this.endTime = newItem[1];
    }

    openPopover() {
        this.visibility = true;
        const tooltip = document.querySelector('#tooltip') as HTMLElement;
        if (tooltip.style.visibility == '' || tooltip.style.visibility == 'hidden') {
            tooltip.style.visibility = 'visible';
        } else if (tooltip.style.visibility == 'visible') {
            tooltip.style.visibility = 'hidden';
            this.visibility = false;
        }
    }

    closePopover() {
        this.visibility = false;
        const tooltip = document.querySelector('#tooltip') as HTMLElement;
        tooltip.style.visibility = 'hidden';
        this.beginTime = null;
        this.endTime = null;
        this.dateFormat = null;
    }

    isIn15MinutesInterval(date = this.currentDate) {
        // Round up to the next multiple of 15 minutes
        const roundedMinutes = Math.ceil(date.getMinutes() / 15) * 15;
        const intervalStart = new Date(date);
        intervalStart.setMinutes(roundedMinutes, 0, 0);

        // Calculate the end of the interval
        const intervalEnd = new Date(intervalStart);
        intervalEnd.setMinutes(intervalStart.getMinutes() + 15);

        return date >= intervalStart && date < intervalEnd;
    }

    previousDate() {
        if (this.totalMinutes === 1440) {
            this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 1));
        } else if (this.totalMinutes === 60) {
            this.currentDate = new Date(this.currentDate.setHours(this.currentDate.getHours() - 1));
        } else if (this.totalMinutes === 15) {
            this.currentDate = new Date(this.currentDate.setMinutes(this.currentDate.getMinutes() - 15));
        }
        this.picker1.select(this.currentDate);
        this.isLoadingRecording = true;
        this.getCameraTimeline(this.currentInterval, this.currentDate);
    }

    nextDate() {
        if (this.totalMinutes === 1440) {
            this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + 1));
        } else if (this.totalMinutes === 60) {
            this.currentDate = new Date(this.currentDate.setHours(this.currentDate.getHours() + 1));
        } else if (this.totalMinutes === 15) {
            this.currentDate = new Date(this.currentDate.setMinutes(this.currentDate.getMinutes() + 15));
        }
        this.picker1.select(this.currentDate);
        this.isLoadingRecording = true;
        this.getCameraTimeline(this.currentInterval, this.currentDate);
    }

    hasNextDate() {
        return !this.isCurrentDate(this.currentDate);
    }

    formatHour(time: string) {
        if (time != null) {
            const formatted = time.split('T', 2);
            return formatted[0];
        }
    }

    timelineResult() {
        this.timelineSub = this.videoTimeline$.subscribe(result => {
            if (result) {
                this.beginDate = result[0].start_time;
                this.endDate = result[0].end_time;
                this.getVideos();
            }
        });
    }

    getVideos() {
        const data = {
            user_sub: localStorage.getItem('sub'),
            child_sub: this.isPartner || this.isAssociate ? this.camera.sub : null,
            camera_id: this.camera.id,
            timeBegin: this.beginDate,
            timeEnd: this.endDate,
            withAlert: false,
            refresh: false
        };
        this.store.dispatch(CameraActions.get_videos(data));
    }

    getVideosResult() {
        this.videoSub = this.playlist$.subscribe(result => {
            if (result) {
                const date = this.formatHour(this.beginDate);
                this.url = result[0][date].recordings[0].url;
            }
        });
    }

    backToLive(camera: Camera) {
        this.currentRecording = null;
        this.noRecording = false;
        this.picker1.select(this.currentDate);
        this.store.dispatch(CameraActions.get_camera_recording_by_date_clear());
        this.loadPlayer(camera);
        this.currentDate = new Date();
        this.getCameraTimeline(this.currentInterval, this.currentDate);
    }

    selectDate(date: HTMLInputElement) {
        this.dateFormat = new Date(date.value).toLocaleDateString('pt-BR').replace(/\//g, '.');
    }

    downloadVideo() {
        this.isDownloading = true;
        fetch(this.url, {
            method: 'GET',
        }).then(response => {
            return response.blob();
        }).then(blob => {
            const recName = this.camName + ' (' + this.dateFormat + ', ' + this.beginTime.replace(':', 'h') + '-' + this.endTime.replace(':', 'h') + ')';
            const blobUrl = URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', recName + '.mp4');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            this.isDownloading = false;
        });
    }
}
